import { Button } from "antd";

export const convertBankList = (data, handleOpenPreview) => {
  let converted = [];

  if (!data) return [];
  data.forEach((item, index) => {
    converted.push({
      key: index + 1,
      id: item.id,
      accountNumber: item?.account_number,
      // cardNumber: item?.gadai_id,
      accountName: item.account_name || "-",
      bankName: item.bank_name || "-",
      // transferProof: (
      //   <Button
      //     onClick={handleOpenPreview(
      //       `gadai-transfer/${item?.gadai_transfer?.id}/proof-picture`
      //     )}
      //     type="link"
      //     style={{ color: "#2C465C" }}
      //   >
      //     Lihat Buku Rekening
      //   </Button>
      // ),
    });
  });
  return converted;
};
